import { SchoolCreate } from './SchoolCreate';
import { SchoolEdit } from './SchoolEdit';
import { SchoolList } from './SchoolList';

export default {
    create: SchoolCreate,
    edit: SchoolEdit,
    list: SchoolList
}
